import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AnimatedPageLoader } from 'smartsuite-ui';
import ErrorBoundary from './components/ErrorBoundary';
import { toastContainerProps } from './constants/toastConstants';

import 'smartsuite-ui/dist/smartsuite-ui.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/react-toastify-overrides.css';
import './i18n';

const ConfigurationAppWrapper = React.lazy(() =>
    import('./apps/Configuration/ConfigurationAppWrapper')
);
const FlightLoadLimits = React.lazy(() =>
    import('./apps/FlightLoadLimits/App')
);
const DefaultRoute = React.lazy(() => import('./components/DefaultRoute'));
const WelcomePage = React.lazy(() => import('./components/WelcomePage'));

const rootElement = document.getElementById('root');

const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

render(
    <ErrorBoundary>
        <Suspense fallback={<AnimatedPageLoader />}>
            <Router basename={window.rootUrl}>
                <Switch>
                    <QueryClientProvider client={queryClient}>
                        <Route
                            path="/apps/Configuration"
                            component={ConfigurationAppWrapper}
                        />
                        <Route
                            path="/apps/flightLoadLimits"
                            component={FlightLoadLimits}
                        />
                        <Route path="/apps/welcome" component={WelcomePage} />
                        <Route exact={true} path="/" component={DefaultRoute} />
                        <ReactQueryDevtools initialIsOpen={false} />
                    </QueryClientProvider>
                </Switch>
            </Router>
            <ToastContainer {...toastContainerProps} />
        </Suspense>
    </ErrorBoundary>,
    rootElement
);
